export default __webpack_public_path__ + "static/media/play_store.c9e37068.png";